import React, { useEffect } from 'react';
import { HiddenInput } from 'components/common';

// Carries a hash value's properties into the form as hidden values so the section calculators can
// read them. For every entry in the hash it registers a hidden form value "<config.name>.<key>"
// (e.g. material_sheet_dimensions.width / .height / .unit). It renders nothing visible — no label,
// no data row (the row is display:none, like every other hidden form field). An absent value (a
// dimension the solution does not have) contributes nothing.
const ReadOnlyHashFormField = ({ config, value, setValue }) => {
  const entries = value != null && typeof value === 'object' ? Object.entries(value) : [];

  useEffect(() => {
    entries.forEach(([key, keyValue]) => {
      setValue(`${config.name}.${key}`, keyValue);
    });
  }, [value]);

  if (entries.length === 0) {
    return null;
  }

  return (
    <tr className="hiddenTr">
      <td colSpan="2">
        {entries.map(([key, keyValue]) => (
          <HiddenInput key={key} name={`${config.name}.${key}`} value={keyValue == null ? '' : keyValue} />
        ))}
      </td>
    </tr>
  );
};

export default ReadOnlyHashFormField;
